import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Column } from 'primereact/column';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/fluent-light/theme.css';
const today = new Date().toISOString().split('T')[0];

function RechargeWalletHistory() {
  const [currentDate, setCurrentDate] = useState('');
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState(false);
  const [userId, setUserId] = useState("");
  const currentUser = useSelector((state) => state.data);
  const [data, setData] = useState(false);
  const [recordData, setRecordData] = useState(false);
  const [users, setUsers] = useState(false);
  const [pageData, setPageData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <IconField iconPosition="right">
        <InputIcon className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
      </IconField>
    </div>
  );
  const handleSearch = async (e) => {
    e.preventDefault();
    const { user_id, type, start_date, end_date } = e.target;
    let rechargeData = {
      user_id: userId,
      type: type.value,
      start_date: start_date.value,
      end_date: end_date.value,
    };
    getData(rechargeData);
  };

  const fetchData = async (event) => {
    let rechargeData = {
      first: event.first,
      rows: event.rows,
      user_id: pageData.user_id,
      type: pageData.type,
      start_date: pageData.start_date,
      end_date: pageData.end_date,
    };
    getData(rechargeData);
  };

  const getData = async (requestData) => {
    try {
      setLoading(true);
      const response = await axios.post("/history/rechargeWalletHistory", requestData);
      const { status, data, records, body, first, rows, totalRecords } = response.data;
      if (status) {
        setData(response.data);
        setRecordData(records);
        setPageData({ ...body, first, rows, totalRecords });
        setLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getData1 = async () => {
    try {
      const response = await axios.get("/get/all/users");
      const { status, users } = response.data;
      if (status) {
        setUsers(users);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    //getData1();
  }, []);

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    setCurrentDate(today);
  }, []);

  useEffect(() => {
    if (query.length < 2) {
      setSuggestions(false);
      setUserId("");
      return;
    }
    axios.get(`/users/search?q=${encodeURIComponent(query)}`).then((res) => {
      setSuggestions(res.data.users); // Adjust to your API response
      setLoading(false);
    }).catch(() => {
      setSuggestions(false);
      setLoading(false);
    });
  }, [query]);

  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Recharge Wallet Search</h4>
              <form className="searchForm" onSubmit={handleSearch}>
                <div className="row">
                  {
                    currentUser && currentUser.user_type == "admin" && (
                      <div class="col-lg-3 col-md-3">
                        <label for="user_id">Users</label>
                        {/* <select class="form-control" name="user_id">
                          <option value="">--Select--</option>
                          {
                            users && users.map(user => (
                              <option value={user._id}>{user.name}</option>
                            ))
                          }
                        </select> */}
                        <input
                          type="text"
                          class="form-control"
                          value={query}
                          onChange={(e) => setQuery(e.target.value)}
                          placeholder="Type to search..."
                        />
                        {suggestions && suggestions.length > 0 && (
                          <ul
                            style={{
                              border: "1px solid #ccc",
                              marginTop: 0,
                              paddingLeft: 0,
                              listStyleType: "none",
                              maxHeight: 150,
                              overflowY: "auto",
                              cursor: "pointer",
                            }}
                          >
                            {suggestions.map((item, idx) => (
                              <li
                                key={idx}
                                style={{ padding: "8px", borderBottom: "1px solid #eee" }}
                                onClick={() => {
                                  setQuery(item.name + "(" + item.mobile + ")"); // Adjust as per your data structure
                                  setUserId(item._id);
                                  setSuggestions(false);
                                }}
                              >
                                {item.name + "(" + item.mobile + ")"}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    )
                  }
                  <div class="col-lg-3 col-md-3">
                    <label>Transaction Type</label>
                    <select class="form-control" name="type">
                      <option value="">All</option>
                      <option value="credit">Credit</option>
                      <option value="debit">Debit</option>
                      <option value="online">Online</option>
                    </select>
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>From Date</label>
                    <input class="form-control" type="date" name="start_date" value={currentDate} max={today} onChange={(e) => setCurrentDate(e.target.value)} />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>To Date</label>
                    <input class="form-control" type="date" name="end_date" max={today} />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <input type="submit" className="search-btn btn btn-primary" value="Search" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              {
                data && (
                  <>
                    <h4 class="card-title">
                      Recharge Wallet History
                    </h4>
                    <div className="row">
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total Credit</strong></label>
                        <div>NPR {(recordData?.totalCredits).toFixed(2)} (₹ {(recordData?.totalCredits / 1.6).toFixed(2)})</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total Debit</strong></label>
                        <div>NPR {(recordData?.totalDebits).toFixed(2)} (₹ {(recordData?.totalDebits / 1.6).toFixed(2)})</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total Online</strong></label>
                        <div>NPR {(recordData?.totalOnline).toFixed(2)} (₹ {(recordData?.totalOnline / 1.6).toFixed(2)})</div>
                      </div>
                    </div>
                    {/* <div className="row">
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Debit Amount</strong></label>
                        <div>{data.totalData.debit}</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Credit Amount</strong></label>
                        <div>{data.totalData.credit}</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Online Amount</strong></label>
                        <div>{data.totalData.online}</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Service Charge</strong></label>
                        <div>{data.totalData.service_charge}</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>GST Charge</strong></label>
                        <div>{data.totalData.gst}</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Add Money Charge</strong></label>
                        <div>{data.totalData.add_money_charge}</div>
                      </div>
                    </div> */}
                    <DataTable
                      value={data.data}
                      size="small"
                      globalFilter={globalFilter}
                      header={header}
                      className="custom-table" // Add custom class here
                      loading={loading}
                    >
                      <Column
                        field="index"
                        header="#"
                        sortable
                        body={(rowData, { rowIndex }) => <span data-label="#">{pageData?.first + rowIndex + 1}</span>}
                      />
                      <Column
                        field="created_at"
                        header="Date"
                        sortable
                        body={(rowData) => <span data-label="Date">{moment(rowData.created_at).format('MMM-DD-YYYY')}<br />{moment(rowData.created_at).format('hh:mm:ss A')}</span>}
                      />
                      <Column
                        field="user_id"
                        header="User(Mobile)"
                        sortable
                        body={(rowData) => <span data-label="User">{rowData?.user_id?.name}<br />({rowData?.user_id?.mobile})</span>}
                      />
                      <Column
                        field="mobile"
                        header="Mobile/Subscriber"
                        sortable
                        body={(rowData) => <span data-label="mobile">{rowData?.rd_id?.mobile}</span>}
                      />
                      <Column
                        field="utr_number"
                        header="PayuId"
                        sortable
                        body={(rowData) => <span data-label="utr_number">{rowData?.utr_number}</span>}
                      />
                      <Column
                        field="amount"
                        header="Amount(₹)"
                        sortable
                        body={(rowData) => <span data-label="Amount(₹)">NPR {(rowData.amount_nc).toFixed(2)}<br />(INR {(rowData.amount_nc / 1.6).toFixed(2)})</span>}
                      />
                      <Column
                        field="transaction_type"
                        header="Type"
                        sortable
                        body={(rowData) => <span data-label="Type" className={rowData?.transaction_type == "credit" ? "success" : "failed"}>{rowData?.transaction_type}</span>}
                      />
                      <Column
                        field="wallet_type"
                        header="WalletType"
                        sortable
                        body={(rowData) => <span data-label="WalletType">{["transfer", "normal", "wallet", "add_money"].includes(rowData.wallet_type) ? "Recharge Wallet" : "Remitance Wallet"}</span>}
                      />
                      <Column
                        field="old_balance"
                        header="OldBalance"
                        sortable
                        body={(rowData) => {
                          return ["transfer", "normal", "wallet", "add_money"].includes(rowData.wallet_type) ? (
                            <span data-label="OldBalance">
                              NPR {rowData.old_balance.toFixed(2)}<br />
                              (INR {(rowData.old_balance / 1.6).toFixed(2)})
                            </span>
                          ) : (
                            <span data-label="OldBalance">
                              NPR {(rowData.old_balance * 1.6).toFixed(2)}<br />
                              (INR {(rowData.old_balance).toFixed(2)})
                            </span>
                          );
                        }}
                      />
                      <Column
                        field="new_balance"
                        header="NewBalance"
                        sortable
                        body={(rowData) => {
                          return ["transfer", "normal", "wallet", "add_money"].includes(rowData.wallet_type) ? (
                            <span data-label="NewBalance">
                              NPR {rowData.new_balance.toFixed(2)}<br />
                              (INR {(rowData.new_balance / 1.6).toFixed(2)})
                            </span>
                          ) : (
                            <span data-label="NewBalance">
                              NPR {(rowData.new_balance * 1.6).toFixed(2)}<br />
                              (INR {(rowData.new_balance).toFixed(2)})
                            </span>
                          );
                        }}
                      />
                      <Column
                        field="message"
                        header="Message"
                        sortable
                        body={(rowData) => <span data-label="Message">{rowData.message}</span>}
                      />
                    </DataTable>
                    <div className="card">
                      <Paginator first={pageData && pageData.first} rows={pageData && pageData.rows} totalRecords={pageData && pageData.totalRecords} rowsPerPageOptions={[5, 10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000]} onPageChange={fetchData} />
                    </div>
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RechargeWalletHistory;
